import React, { useCallback } from 'react';
import styled from 'styled-components';

import TableDataCell from './TableDataCell';

import ImageManager from '../../../misc/ImageManager';

import FieldTypes from '../../../../constants/FieldTypes';

const StyledImageManagerWrapper = styled.div`
  height: 100%;
  padding: 2px;
`;

const TableFieldImageCell = ({

  focused,

  id,
  rowId,
  columnId,
  columnIdentifier,
  columnType,
  cellKey,
  fontColor,
  borderRadius,
  borderWidth,
  borderColor,
  backgroundColor,
  primaryColor,
  dangerColor,
  width,

  onUpload,
  onChange,
  onFocus,
  onLoadCompleted,

  value,
  disabled,
  isMobileView,

  maxImageWidth,
  maxImageHeight,

}) => {

  const values = Array.isArray(value) ? value : [value];

  const handleDrop = useCallback((files, loadingCallback, errorCallback) => {
    onUpload(rowId, columnId, files, loadingCallback, errorCallback);
  }, [rowId, columnId]);

  const handleDelete = useCallback((i) => {

    const nextImageValues = [...values];
    nextImageValues.splice(i, 1);

    onChange(rowId, columnId, nextImageValues);

  }, [rowId, columnId, values]);

  const handleFocus = () => {

    if (onFocus) {
      onFocus(rowId, columnId, columnIdentifier, {}, columnType,);
    }

  };

  const handleLoadCompleted = useCallback(() => {
    if (onLoadCompleted) onLoadCompleted(columnId);
  }, [columnId]);

  /**
   * If the column width is less than maxImageWidth then the column width
   * will be applied as the maxImageWidth so that images would be placed within
   * cell boundary
   */
  const validMaxImageWidth = width && width < maxImageWidth ? width : maxImageWidth;

  return (
    <TableDataCell
      key={cellKey}
      data-testid={`${id}-${rowId}-${columnId}-image-cell`}
      {...{
        disabled,
        focused,
        primaryColor,
        width,
        borderColor,
        borderWidth,
        backgroundColor,
        padding: 0,
      }}
    >
      <StyledImageManagerWrapper>
        <ImageManager
          {...{
            type: FieldTypes.image, // Type is needed to only allow images for image field
            value,
            multiple: true,
            disabled,
            isMobileView,

            maxWidth: maxImageWidth ? `${validMaxImageWidth}px` : 0,
            maxHeight: maxImageHeight ? `${maxImageHeight}px` : 0,
            onLoadCompleted: handleLoadCompleted,
            onDelete: handleDelete,
            onFocus: handleFocus,
            onDrop: handleDrop,

            primaryColor,
            dangerColor,
            fontColor,
            backgroundColor,
            borderRadius,
            borderColor,
            padding: 2, //Default spacing around images
            borderWidth: 1,
          }}
        />
      </StyledImageManagerWrapper>
    </TableDataCell>
  );
};

export default React.memo(TableFieldImageCell);
